import React, { useState,useEffect } from "react";
import axios from "axios";
import { Link,useNavigate, useLocation } from "react-router-dom";
import API_URLS from "../config/apiConfig";
import swal from 'sweetalert';
import { ClipLoader } from "react-spinners";
import InlineEditorComponent from "../components/InlineEditorComponent";



const CourseForm = () => {
   const authToken = localStorage.getItem("token");
   const navigate = useNavigate();
   const location = useLocation();
   const [loading, setLoading] = useState(false);
   const [categories, setCategories] = useState([]);
   const [photo, setPhoto] = useState(null);
   const [removeExistingPhoto, setRemoveExistingPhoto] = useState(false);
   const [formData, setFormData] = useState({
      id: null,
      category_id: "",
      course_name: "",
      photo:"",
     // description: "",     
    });
   const recordToEdit = location.state?.course;
   const [errors, setErrors] = useState({});  
   useEffect(() => {
    if (recordToEdit) {
      console.log(recordToEdit);
      setFormData({
        id: recordToEdit.id, // Include the id
        category_id: recordToEdit.category_id,
        course_name: recordToEdit.course_name,
        description: recordToEdit.description,
        photo: recordToEdit.image_thumb_url,
      });    
      setPhoto(recordToEdit.image_thumb_url);
    }
  }, [recordToEdit]);
 
  console.log("desc "+formData.description);
  const fetchCategories = async () => {
    try {
        
      const response = await axios.post(API_URLS.COURSES_CATEGORIES,null, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
    
      if(response.data.success==1){
      setCategories(response.data.listData.data);
     
      }else{
      swal("Error", response.data.message, "error");  
      }
     
    } catch (error) {
      console.error('Error fetching categories:', error);
     
    }
  };
  useEffect(() => {
    fetchCategories();
  }, []);  
  
  
  // Handle input changes
  const handleChange = (e) => {

    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" }); // Clear errors on input change
  };
  const handleDescriptionChange = (value) => {
    setFormData((prevData) => ({
        ...prevData,
        description: value, // Update description
    }));
};

const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
     setPhoto(URL.createObjectURL(file));
     setFormData({ ...formData, image: URL.createObjectURL(file) });
     setRemoveExistingPhoto(false);
  }
};

const handleRemoveImage = () => {
  setPhoto(null); // Clear preview
  setFormData((prevData) => ({
    ...prevData,
    photo: null,
  }));
  setRemoveExistingPhoto(true); // Mark existing image for removal
};

   // Validate form inputs
   const validate = () => {
    const newErrors = {};
   
   if (!formData.course_name.trim()){ newErrors.course_name = "Please enter course name";}
   return newErrors;
   };
    // Handle form submission
   const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setLoading(true);
    try {
      console.log(formData);
      //return false;
    const data = new FormData();
    data.append('course_name', formData.course_name);
    data.append('description', formData.description);
    data.append('category_id', formData.category_id);
    data.append('id', formData.id);
    data.append('remove_photo', removeExistingPhoto ? 1 : 0); 
    if(photo){
      const fileInput = document.querySelector('input[type="file"]');
      data.append('photo', fileInput.files[0]);
    }
    const response = await axios.post(API_URLS.COURSES_SAVE, data,{
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'multipart/form-data'
        },
      });
      if(response.data.success==1){
      swal("Success", response.data.message, "success").then(() => {
        navigate("/manager/courses"); // Redirect to the target page
      });
     
      }else{
      swal("Error", response.data.message, "error");  
      }
      
      console.log(response.data); // Handle response
    } catch (error) {
      swal("Error", "Please try again.", "error");  
      console.error("Error:", error.response?.data || error.message);
    }finally {
      setLoading(false); 
    }
  };

 
    return (
    <>    
     {loading && (
                    <div className="loader-overlay">
                        <ClipLoader color="#08A9E6" loading={loading} size={50} />
                    </div>
                )}
    <div className="contact-form">
                                    <h3 className="user-title"> {recordToEdit ? 'Edit Course' : 'Add Course'} </h3>
                                    <form id="signupForm" name="signupForm" method="post" onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <input type="text" className="form-control" name="course_name"  placeholder="Course Name" value={formData.course_name}  onChange={handleChange} />
                                  {errors.course_name && <p style={{ color: "red" }}>{errors.course_name}</p>}
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <select  className="form-control" name="category_id" value={formData.category_id} onChange={handleChange}>
                                                    <option value="">Select Category</option>
                                                    {categories.map((category) => (
                                                    <option key={category.id} value={category.id}>
                                                        {category.category}
                                                    </option>
                                                    ))}
                                                    </select>
                                                    {errors.category_id && <p style={{ color: "red" }}>{errors.category_id}</p>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                <label htmlFor="description" className="form-label">Course Description</label>
                                              <InlineEditorComponent
                                                name="description"
                    value={formData.description}
                    onChange={handleDescriptionChange} 
                />
                                 {errors.description && <p style={{ color: "red" }}>{errors.description}</p>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12">
                                            <label>Cover Image</label>
                                                <div className="form-group">
                                              
                <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                />
                {photo && (
                    <div>
                       
                        <img src={photo} alt="Cover Preview" width="200" />
                        <span onClick={handleRemoveImage} title="Remove Image"><i className="fa fa-trash"></i></span>
                    </div>
                )}

{!photo && formData.photo && !removeExistingPhoto && (
    <div>
      <img src={formData.photo} alt="Current Cover" width="200" />
      <button
        type="button"
        onClick={handleRemoveImage}
        className="btn btn-danger btn-sm mt-2" title="Remove Image"
      >
        Remove Image
      </button>
    </div>
  )}

                                                  </div>
                                             </div>
                                        </div>
                                            <div className="row">
                                            <div className="col-lg-12 col-md-12 mt-2">
                                                <button type="submit" className="default-btn" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                                </button>
                                                {recordToEdit && (
                                                <Link to={`/manager/course-chapter?course_id=${formData.id}`} className="ms-3">Manage Chapters & Pages</Link>

                                                )}                      
                                                </div>
                                        </div>
                                    </form>
                                </div>
    
    </>
    );
}
export default CourseForm;